import img17a from '../../../assets/gallery/17e/17e-01-HOME_Los-Angeles-Steve-Turner.jpg';
import img17b from '../../../assets/gallery/17e/17e-02_ST-2017-305x610cm-oleo-sobre-madera.jpg';
import img17c from '../../../assets/gallery/17e/17e-03_ST-2017-305x610cm-oleo-sobre-madera.jpg';
import img17d from '../../../assets/gallery/17e/17e-04_ST-2017-305x610cm-oleo-sobre-madera.jpg';
import img17e from '../../../assets/gallery/17e/17e-05_Vista-estudio-Los-Angeles.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img17a,
    description: "2017",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "305 x 610 cm",
    pictureSrc: img17b,
    description: "2017",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "305 x 610 cm",
    pictureSrc: img17c,
    description: "2017",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "305 x 610 cm",
    pictureSrc: img17d,
    description: "2017",
    orientation: "h"
  },
  {
    id: 5,
    title: "",
    dimensions: "",
    pictureSrc: img17e,
    description: "2017",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/17e/data17e.js